import React from 'react';
import PropTypes from 'prop-types';

import { css, withStyles, withStylesPropTypes } from 'airbnb-dls-web/build/themes/withStyles';
import Title from 'airbnb-dls-web/build/exp/Title';
import { Tab } from 'airbnb-dls-web/build/exp/Tabs';

import Spacing from 'airbnb-dls-web/build/exp/Spacing';
import Rule from 'airbnb-dls-web/build/exp/Rule';
import TabsController from 'airbnb-dls-web/build/exp/Tabs/TabsController';
import Button from 'airbnb-dls-web/build/exp/Button';
import Panel from 'airbnb-dls-web/build/exp/Panel';
import Text from 'airbnb-dls-web/build/exp/Text';
import HeadingSection from 'airbnb-dls-web/build/exp/HeadingSection';

import TechTalks from '../../components/TechTalks';
import CenterText from '../../components/CenterText';
import UncontrolledInput from '../../components/UncontrolledInput';

const propTypes = {
  ...withStylesPropTypes,
};

const SHOW_EMAIL_SIGNUP = false;

function UpcomingEventsEmailSignup() {
  return (
    <Panel>
      <Spacing horizontal={0} vertical={2}>
        <CenterText>
          <form action="http://airbnb3.createsend.com/t/j/s/auhku/" method="post">
            <Text small>Subscribe to get invited to future tech talks</Text>
            <UncontrolledInput
              id="fieldEmail"
              name="cm-auhku-auhku"
              type="email"
              placeholder="Enter your email address"
            />
            <Button small block type="submit">
              Subscribe
            </Button>
          </form>
        </CenterText>
      </Spacing>
    </Panel>
  );
}

function EventSectionHero({ title, subtitle }) {
  return (
    <div>
      <Spacing top={5} bottom={5}>
        <Spacing bottom={1}>
          <Title level={3}>{title}</Title>
        </Spacing>
        <Text light>{subtitle}</Text>
      </Spacing>

      <Rule hero />
    </div>
  );
}

EventSectionHero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

class EventsHomepage extends React.PureComponent {
  render() {
    const { styles, data: { allTechTalksYaml, allTakingFlightYaml, allOpenAirYaml } } = this.props;

    const techTalks = allTechTalksYaml.edges.map(talk => talk.node);

    // We(tech brand team) decide to hide the "Taking Flight" and "Open Air"
    // tabs since we haven't organized these events for years. We will uncomment
    // these codes once there are new events in the futhre.
    //
    // const takingFlight = allTakingFlightYaml.edges.map(talk => talk.node);
    // const openAir = allOpenAirYaml.edges.map(talk => talk.node);

    return (
      <HeadingSection>
        {SHOW_EMAIL_SIGNUP && (
          <Spacing vertical={4}>
            <div {...css(styles.emailSignupWrapper)}>
              <UpcomingEventsEmailSignup />
            </div>
          </Spacing>
        )}

        <Spacing right={2}>
          <TechTalks techTalkList={techTalks} />
          {/* <TabsController scrollable>
            <Tab label="Tech Talks">
              <TechTalks techTalkList={techTalks} />
            </Tab>
            <Tab label="Taking Flight">
              <EventSectionHero
                title="Taking Flight"
                subtitle="An event series for underrepresented groups in tech"
              />

              {takingFlight.map(event => <Event key={event.title} event={event} />)}
            </Tab>
            <Tab label="Open Air">
              <EventSectionHero
                title="OpenAir 2015"
                subtitle="OpenAir focused on creating engineering solutions to the challenges
                      of matching. The brightest minds in the industry came
                      together to tackle such issues as search and discovery,
                      trust, internationalization, mobile, and infrastructure.
                      We heard from: Netflix, Stripe, Periscope, LinkedIn, Etsy,
                      Pinterest, Lyft, Quora, HomeJoy, Watsi, Instagram,
                      Facebook, and Google.org"
              />
              {openAir.map(event => <Event key={event.title} event={event} />)}
              </Tab>
          </TabsController> */}
        </Spacing>
      </HeadingSection>
    );
  }
}

EventsHomepage.propTypes = propTypes;

export default withStyles(({ responsive }) => ({
  emailSignupWrapper: {
    [responsive.mediumAndAbove]: {
      width: '50%',
      margin: '0 auto',
    },
  },
}))(EventsHomepage);

export const pageQuery = graphql`
  query EventsQuery {
    allTechTalksYaml {
      edges {
        node {
          title
          tags
          slides
          eventLink
          date
          video {
            youtube
          }
          speakers {
            name
            role
            company
          }
          imageLink
          location
        }
      }
    }
    allTakingFlightYaml {
      edges {
        node {
          title
          tags
          # Can comment back in when taking flight has eventLink again on one of the events
          # eventLink
          date(formatString: "MMM D, YYYY")
          video {
            youtube
          }
          speakers {
            name
            role
            company
          }
        }
      }
    }
    allOpenAirYaml {
      edges {
        node {
          title
          tags
          video {
            youtube
          }
          speakers {
            name
            role
            company
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/events/index.jsx